'use client';

import { useSyncExternalStore } from 'react';

export type LocationsView = 'list' | 'map';

export const ALL_REGIONS = '__all__';

// The finder and the map are in different CMS blocks with no shared parent,
// so we use this small store instead of props or context.
let view: LocationsView = 'list';
let region: string = ALL_REGIONS;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach(listener => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function setLocationsView(next: LocationsView) {
  if (view === next) return;
  view = next;
  emit();
}

export function setSelectedRegion(next: string) {
  if (region === next) return;
  region = next;
  emit();
}

export function useLocationsView() {
  return useSyncExternalStore(
    subscribe,
    () => view,
    () => 'list' as const
  );
}

export function useSelectedRegion() {
  return useSyncExternalStore(
    subscribe,
    () => region,
    () => ALL_REGIONS
  );
}
